import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import * as userDeviceApi from '../../api/userDevice';
import { message } from 'antd';

// 获取用户设备列表
export const fetchUserDevices = createAsyncThunk(
  'userDevice/fetchList',
  async (params = {}, { rejectWithValue }) => {
    try {
      const response = await userDeviceApi.getUserDeviceList(params);
      if (response && response.code === 200) {
        // 返回数据和查询参数，以便在reducer中保存
        return {
          data: response.data,
          params
        };
      }
      return rejectWithValue(response?.message || '获取用户设备列表失败');
    } catch (error) {
      return rejectWithValue(error.message || '获取用户设备列表失败');
    }
  }
);

// 初始状态
const initialState = {
  // 用户设备列表
  userDeviceList: {
    data: [],
    total: 0,
    current: 1,
    size: 10,
    loading: false,
    error: null,
    searchParams: {
      userId: undefined,
      deviceId: undefined,
      deviceType: undefined
    }
  }
};

// 创建Slice
const userDeviceSlice = createSlice({
  name: 'userDevice',
  initialState,
  reducers: {
    setSearchParams: (state, action) => {
      state.userDeviceList.searchParams = {
        ...state.userDeviceList.searchParams,
        ...action.payload
      };
    }
  },
  extraReducers: (builder) => {
    builder
      // 处理获取用户设备列表
      .addCase(fetchUserDevices.pending, (state) => {
        state.userDeviceList.loading = true;
        state.userDeviceList.error = null;
      })
      .addCase(fetchUserDevices.fulfilled, (state, action) => {
        state.userDeviceList.loading = false;
        state.userDeviceList.data = action.payload.data.records || [];
        state.userDeviceList.total = action.payload.data.total || 0;
        state.userDeviceList.current = action.payload.data.current || 1;
        state.userDeviceList.size = action.payload.data.size || 10;
        
        // 保存搜索参数
        if (action.payload.params) {
          state.userDeviceList.searchParams = {
            ...state.userDeviceList.searchParams,
            ...action.payload.params
          };
        }
      })
      .addCase(fetchUserDevices.rejected, (state, action) => {
        state.userDeviceList.loading = false;
        state.userDeviceList.error = action.payload;
        message.error(action.payload || '获取用户设备列表失败');
      });
  }
});

export const { setSearchParams } = userDeviceSlice.actions;

export default userDeviceSlice.reducer; 